
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IConfigOptions } from '../../../models/IConfigOptions';
import { IMenuOptions } from '../../../models/IMenuOptions';
import { IColumnDetails } from '../../../models/ITableData';
import { CSVService } from '../../../services/csv-menu/csv.service';
import { IFileData } from '../../../models/IFileData';
 
@Component({
  selector: 'ff-csv-menu',
  templateUrl: './csv-menu.component.html',
  styleUrls: ['./csv-menu.component.scss']
})
export class CsvMenuComponent implements OnInit{

  @ViewChild("inputFile") inputFile: ElementRef;
  /**
   * Options to display as menu items for the top list
   * Use the IMenuOptions interface: { label: string; icon?: string; callback: () => void; args?: any[]; }
   * * @internal
  */
  @Input() import: IMenuOptions;

    /**
   * Options to display as menu items for the top list
   * Use the IMenuOptions interface: { label: string; icon?: string; callback: () => void; args?: any[]; }
   * * @internal
  */
  @Input() export: IMenuOptions;

  
      /**
   * Options to display as options in the dropdown
   * Use the IConfigOptions interface: { disabled: boolean; }
   * * @internal
  */
  @Input() config?: IConfigOptions 

   /**
   * The attributes belonging to each item in the table
   * @internal
   */
  @Input() inputProperties: IColumnDetails[] = [];

      /**
   * Options to display as menu items for the top list
   * Use the IMenuOptions interface: { label: string; icon?: string; callback: () => void; args?: any[]; }
   * * @internal
  */
  @Output() data = new EventEmitter<any>();


  toggledMenu : boolean = false;

  //boolean variable to control disabled property of the component
  isDisabled : boolean = false;

  constructor() { }

  ngOnInit() {
    this.isDisabled = this.config != undefined ? this.config.disabled : false;
  }

  menuChange() {
    this.toggledMenu = !this.toggledMenu;
  }

  exportCSV(){
    this.export.callback(this.export.args);
  }

  importCSV() {
    let inputElem = this.inputFile.nativeElement as HTMLInputElement;
    inputElem.click();
    this.import.callback(this.import.args);
  }

  handleFileInput(event : any) {
    let file = event.target.files[0];
    this.inputFile.nativeElement.value = null;

    CSVService.parseCSV(file).subscribe(data => {
      const fileData : IFileData = {
        fileName: file.name,
        data: data
      }
      this.data.emit(fileData);
    });
  }

  
}
